export const SvgImport1 = () => (
  <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="26" height="26" transform="translate(26 25)" fill="white" />
    <circle cx="39" cy="38" r="13" fill="url(#paint0_linear_815_993)" />
    <g filter="url(#filter0_b_815_993)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8569 12.171C15.0409 12.0373 15.2312 11.9143 15.4289 11.8012C15.4924 11.9426 15.5822 12.0751 15.6984 12.1913C17.9569 14.4497 19.7296 16.2196 21.2923 17.4703C22.8743 18.7365 24.3559 19.5677 26.0629 19.838C27.1058 20.0032 28.1682 20.0032 29.2111 19.838C30.8704 19.5752 32.3165 18.7827 33.849 17.5757C35.362 16.3842 37.0606 14.7047 39.1987 12.5682C39.2673 12.4996 39.3267 12.4254 39.377 12.3469C40.0236 12.8506 40.5966 13.4429 41.0789 14.1068C42.75 16.4068 42.75 19.6878 42.75 26.2499V29.7499C42.75 36.3119 42.75 39.5929 41.0789 41.893C40.5392 42.6358 39.886 43.2891 39.1431 43.8288C36.843 45.4999 33.562 45.4999 27 45.4999C20.438 45.4999 17.157 45.4999 14.8569 43.8288C14.1141 43.2891 13.4608 42.6358 12.9211 41.893C11.25 39.5929 11.25 36.3119 11.25 29.7499V26.2499C11.25 19.6878 11.25 16.4068 12.9211 14.1068C13.4608 13.3639 14.1141 12.7107 14.8569 12.171Z"
        fill="#7C68FB"
        fillOpacity="0.35"
      />
      <path
        d="M27 10.4999C31.7249 10.4999 34.7487 10.4999 36.9302 11.1237C34.9695 13.0792 33.503 14.5069 32.2249 15.5135C30.8782 16.574 29.8459 17.0798 28.8005 17.2453C28.0297 17.3674 27.2444 17.3674 26.4735 17.2453C25.3981 17.075 24.3368 16.5448 22.9326 15.4209C21.6251 14.3744 20.1208 12.8981 18.104 10.8843C20.1903 10.4999 22.9792 10.4999 27 10.4999Z"
        fill="#7C68FB"
        fillOpacity="0.35"
      />
      <path
        d="M15.7026 11.6783L15.5671 11.3764L15.2799 11.5408C15.0728 11.6593 14.8734 11.7882 14.6805 11.9283C13.9122 12.4865 13.2366 13.1621 12.6784 13.9304C11.7995 15.1401 11.3723 16.5942 11.1606 18.5478C10.95 20.4919 10.95 22.9659 10.95 26.2308V26.2499V29.7499V29.769C10.95 33.0339 10.95 35.5079 11.1606 37.452C11.3723 39.4055 11.7995 40.8596 12.6784 42.0693C13.2366 42.8376 13.9122 43.5133 14.6805 44.0715C15.8902 44.9504 17.3443 45.3776 19.2979 45.5892C21.242 45.7999 23.716 45.7999 26.9809 45.7999H27H27.0191C30.284 45.7999 32.758 45.7999 34.7021 45.5892C36.6557 45.3776 38.1098 44.9504 39.3195 44.0715C40.0878 43.5133 40.7634 42.8376 41.3216 42.0693C42.2005 40.8596 42.6277 39.4055 42.8394 37.452C43.05 35.5079 43.05 33.0339 43.05 29.769V29.7499V26.2499V26.2308C43.05 22.9659 43.05 20.4919 42.8394 18.5478C42.6277 16.5942 42.2005 15.1401 41.3216 13.9304C40.8227 13.2438 40.2301 12.6312 39.5613 12.1102L39.3018 11.9081L39.1244 12.1851C39.0857 12.2454 39.0398 12.3028 38.9866 12.3559C36.8449 14.4962 35.1597 16.1617 33.6634 17.34C32.1521 18.5302 30.7533 19.29 29.1642 19.5417C28.1524 19.702 27.1217 19.702 26.1098 19.5417C24.475 19.2828 23.0415 18.486 21.4798 17.2361C19.933 15.9981 18.1734 14.242 15.9105 11.9792C15.8205 11.8892 15.7514 11.787 15.7026 11.6783ZM37.142 11.3361L37.5035 10.9756L37.0126 10.8353C34.7907 10.1999 31.7321 10.1999 27.0641 10.1999L27 10.1999H26.9626C22.9742 10.1999 20.1629 10.1999 18.0497 10.5893L17.4877 10.6928L17.8921 11.0966C19.9059 13.1075 21.4223 14.5964 22.7451 15.6551C24.1697 16.7953 25.279 17.3599 26.4266 17.5416C27.2286 17.6687 28.0455 17.6687 28.8474 17.5416C29.963 17.3649 31.0426 16.8265 32.4105 15.7491C33.7048 14.7298 35.1839 13.2891 37.142 11.3361Z"
        stroke="url(#paint1_linear_815_993)"
        strokeWidth="0.6"
        strokeLinecap="round"
      />
    </g>
    <g filter="url(#filter1_d_815_993)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.5 26.6874C22.7751 26.6874 22.1875 27.275 22.1875 27.9999C22.1875 28.7248 22.7751 29.3124 23.5 29.3124H30.5C31.2249 29.3124 31.8125 28.7248 31.8125 27.9999C31.8125 27.275 31.2249 26.6874 30.5 26.6874H23.5ZM20 33.6874C19.2751 33.6874 18.6875 34.275 18.6875 34.9999C18.6875 35.7248 19.2751 36.3124 20 36.3124H34C34.7249 36.3124 35.3125 35.7248 35.3125 34.9999C35.3125 34.275 34.7249 33.6874 34 33.6874H20Z"
        fill="url(#paint2_linear_815_993)"
      />
    </g>
    <defs>
      <filter
        id="filter0_b_815_993"
        x="-13.3501"
        y="-14.1001"
        width="80.7002"
        height="84.2"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="12" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_815_993" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_815_993" result="shape" />
      </filter>
      <filter
        id="filter1_d_815_993"
        x="16.734"
        y="24.7339"
        width="24.439"
        height="17.439"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="1.9535" dy="1.9535" />
        <feGaussianBlur stdDeviation="1.9535" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.486275 0 0 0 0 0.407843 0 0 0 0 0.984314 0 0 0 1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_815_993" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_815_993" result="shape" />
      </filter>
      <linearGradient
        id="paint0_linear_815_993"
        x1="26"
        y1="51"
        x2="52.554"
        y2="25.5787"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5E48EC" />
        <stop offset="1" stopColor="#7C68FB" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_815_993"
        x1="11.25"
        y1="10.4999"
        x2="46.0706"
        y2="41.8066"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.25" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_815_993"
        x1="27.14"
        y1="38.3629"
        x2="38.7758"
        y2="18.6618"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.2" />
      </linearGradient>
    </defs>
  </svg>
);

export const SvgImport2 = () => (
  <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M31.8778 28.395C27.826 24.3432 25.8 22.3173 25.8 19.7998C25.8 17.2823 27.826 15.2564 31.8778 11.2046L32.2048 10.8775C36.2567 6.82572 38.2826 4.7998 40.8 4.7998C43.3175 4.7998 45.3434 6.82572 49.3953 10.8775L49.7223 11.2046C53.7741 15.2564 55.8001 17.2823 55.8001 19.7998C55.8001 22.3173 53.7741 24.3432 49.7223 28.395L49.3953 28.7221C45.3434 32.7739 43.3175 34.7998 40.8 34.7998C38.2826 34.7998 36.2567 32.7739 32.2048 28.7221L31.8778 28.395Z"
      fill="url(#paint0_linear_815_1003)"
    />
    <g filter="url(#filter0_b_815_1003)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.11 16.8598C46.2 18.9989 46.2 21.7991 46.2 27.3997V32.7973C46.2 33.3566 46.2 33.6362 46.1888 33.8725C45.9449 39.0237 41.8239 43.1446 36.6728 43.3885C36.4365 43.3997 36.1246 43.3997 35.5007 43.3997L35.3406 43.3999C33.3001 43.4129 31.3124 44.0499 29.6444 45.2253L29.5384 45.3008L24.3169 49.0304C22.5269 50.309 20.1748 48.4625 20.9918 46.4202C21.5705 44.9734 20.505 43.3997 18.9468 43.3997H17.7433C13.5772 43.3997 10.2 40.0224 10.2 35.8563V27.3997C10.2 21.7991 10.2 18.9989 11.2899 16.8598C12.2486 14.9781 13.7784 13.4483 15.66 12.4896C17.7992 11.3997 20.5994 11.3997 26.2 11.3997H30.2C35.8005 11.3997 38.6007 11.3997 40.7399 12.4896C42.6215 13.4483 44.1513 14.9781 45.11 16.8598Z"
        fill="#7C68FB"
        fillOpacity="0.35"
      />
      <path
        d="M46.5 27.3997V27.3855C46.5 24.5972 46.5 22.487 46.3627 20.8072C46.225 19.1212 45.9474 17.8425 45.3773 16.7236C44.3898 14.7855 42.8141 13.2098 40.8761 12.2223C39.7572 11.6522 38.4784 11.3747 36.7924 11.2369C35.1126 11.0997 33.0024 11.0997 30.2141 11.0997H30.2H26.2H26.1858C23.3975 11.0997 21.2873 11.0997 19.6075 11.2369C17.9215 11.3747 16.6427 11.6522 15.5238 12.2223C13.5858 13.2098 12.0101 14.7855 11.0226 16.7236C10.4525 17.8425 10.1749 19.1212 10.0372 20.8072C9.89995 22.487 9.89995 24.5972 9.89995 27.3855V27.3997V35.8563C9.89995 40.1881 13.4115 43.6997 17.7433 43.6997H18.9468C20.2927 43.6997 21.2131 45.0591 20.7132 46.3087C19.785 48.6293 22.4575 50.7272 24.4913 49.2745L29.7124 45.5452L29.7128 45.5449L29.8172 45.4705C29.8174 45.4704 29.8176 45.4703 29.8178 45.4701C31.4355 44.3303 33.3632 43.7126 35.3421 43.6999C35.3423 43.6999 35.3424 43.6999 35.3425 43.6999L35.5007 43.6997H35.5011H35.5145C36.1255 43.6997 36.4436 43.6997 36.687 43.6881C41.9927 43.437 46.2372 39.1924 46.4884 33.8867C46.5 33.6433 46.5 33.3573 46.5 32.8092V32.7973V27.3997Z"
        stroke="url(#paint1_linear_815_1003)"
        strokeWidth="0.6"
        strokeLinecap="round"
      />
    </g>
    <g filter="url(#filter1_d_815_1003)">
      <path
        d="M24.2 24.8997H32.2C33.0284 24.8997 33.7 24.2281 33.7 23.3997C33.7 22.5712 33.0284 21.8997 32.2 21.8997H24.2C23.3715 21.8997 22.7 22.5712 22.7 23.3997C22.7 24.2281 23.3715 24.8997 24.2 24.8997Z"
        fill="url(#paint2_linear_815_1003)"
      />
      <path
        d="M20.2 29.8997C19.3715 29.8997 18.7 30.5712 18.7 31.3997C18.7 32.2281 19.3715 32.8997 20.2 32.8997H36.2C37.0284 32.8997 37.7 32.2281 37.7 31.3997C37.7 30.5712 37.0284 29.8997 36.2 29.8997H20.2Z"
        fill="url(#paint3_linear_815_1003)"
      />
    </g>
    <defs>
      <filter
        id="filter0_b_815_1003"
        x="-14.4001"
        y="-13.2003"
        width="85.2002"
        height="87.2559"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="12" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_815_1003" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_815_1003" result="shape" />
      </filter>
      <filter
        id="filter1_d_815_1003"
        x="16.7465"
        y="19.9462"
        width="26.814"
        height="18.814"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="1.9535" dy="1.9535" />
        <feGaussianBlur stdDeviation="1.9535" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.486275 0 0 0 0 0.407843 0 0 0 0 0.984314 0 0 0 0.5 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_815_1003" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_815_1003" result="shape" />
      </filter>
      <linearGradient
        id="paint0_linear_815_1003"
        x1="40.8"
        y1="4.7998"
        x2="40.8"
        y2="34.7998"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#7C68FB" />
        <stop offset="1" stopColor="#361DD3" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_815_1003"
        x1="10.2"
        y1="11.3997"
        x2="48.2113"
        y2="47.3241"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.25" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_815_1003"
        x1="28.3599"
        y1="35.2431"
        x2="41.658"
        y2="12.7276"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.2" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_815_1003"
        x1="28.3599"
        y1="35.2431"
        x2="41.658"
        y2="12.7276"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.2" />
      </linearGradient>
    </defs>
  </svg>
);

export const SvgArrow = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.528 6.46731C16.2338 6.17573 15.7589 6.17784 15.4673 6.47204C15.1757 6.76624 15.1778 7.24111 15.472 7.53269L17.235 9.28C17.9505 9.98914 18.4413 10.4772 18.7734 10.8907C18.8813 11.0251 18.9655 11.1434 19.0309 11.25L4 11.25C3.58579 11.25 3.25 11.5858 3.25 12C3.25 12.4142 3.58579 12.75 4 12.75L19.0309 12.75C18.9655 12.8566 18.8813 12.9749 18.7734 13.1093C18.4413 13.5228 17.9505 14.0109 17.235 14.72L15.472 16.4673C15.1778 16.7589 15.1757 17.2338 15.4673 17.528C15.7589 17.8222 16.2338 17.8243 16.528 17.5327L18.3227 15.7539C18.9987 15.084 19.5511 14.5364 19.9429 14.0485C20.3504 13.5412 20.6453 13.0263 20.7241 12.4082C20.7414 12.2726 20.75 12.1363 20.75 12C20.75 11.8637 20.7414 11.7274 20.7241 11.5918C20.6453 10.9737 20.3504 10.4588 19.9429 9.95146C19.5511 9.46358 18.9987 8.91604 18.3227 8.24609L16.528 6.46731Z"
      fill="#475467"
    />
  </svg>
);

export const SvgCollapse = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.84611 13.5382L9.4615 13.5382C10.0138 13.5382 10.4615 13.9859 10.4615 14.5382L10.4615 18.1535"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path d="M9.69248 14.3073L4.30786 19.6919" stroke="#667085" strokeWidth="1.5" strokeLinecap="round" />
    <path
      d="M13.5382 5.84654L13.5382 9.46193C13.5382 10.0142 13.9859 10.4619 14.5382 10.4619L18.1535 10.4619"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path d="M14.3075 9.69266L19.6921 4.30804" stroke="#667085" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export const SvgExpand = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.61539 19.3846L5 19.3846C4.44772 19.3846 4 18.9369 4 18.3846L4 14.7692M4.76918 18.6155L10.1538 13.2309M19.3844 8.61516L19.3844 4.99977C19.3844 4.44749 18.9367 3.99977 18.3844 3.99977L14.769 3.99977M18.6152 4.76904L13.2305 10.1537"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
